import type { SearchAlgoliaHit } from 'modules/search/algolia/types/SearchAlgoliaHit';

export function searchContextHeaderGetUrl(
  result: SearchAlgoliaHit | undefined,
) {
  if (!result) return '';

  if (result.type === 'IMPORTED') {
    const source = result.source
      ? result.source.replace(/_/g, '-').toLowerCase()
      : '';

    return `/${CURRENT_LOCALE()}/imported-action-opps/${source}/${result.objectID.replace(
      `${result.source}_`,
      '',
    )}`;
  }

  if (typeof result.url === 'string') return result.url;

  return result.url[CURRENT_LOCALE()];
}
